import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";
import { HTS_ISOLATED_OLD_INCIDENT_NOTE } from "./sharedNotes";

export const onlineSocialMediaConduct: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.ONLINE_SOCIAL_MEDIA_CONDUCT,
  label: "Social media and online presence",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what the content was, in general terms",
    "when it was posted or happened",
    "what platform it was on",
    "whether it's still up",
    "how the candidate thinks about it now",
  ],
  followUpTriggers: [
    "the content or platform is described too vaguely to judge",
    "there's no indication of when it happened or whether it's still up",
    "there's no reflection on how the candidate views it now",
    "it's unclear whether the conduct was isolated or part of a pattern",
  ],
  hardBarrierFacts: [
    "content that is hateful, threatening, or involves intimate images",
  ],
  crossCuttingNotes: [
    "an immature post from years ago that's owned honestly usually becomes a coaching conversation about cleanup and disclosure, not a flag",
    "cyberbullying/online harassment: a one-off argument that got personal resolves differently than a pattern of targeting someone, which flags for human review",
    HTS_ISOLATED_OLD_INCIDENT_NOTE,
    "accounts under other names or aliases are simply recorded with the platforms involved, plus one follow-up about whether anything on those accounts would concern a recruiter",
  ],
};
